import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "flex justify-center" };
const _hoisted_4 = ["onClick"];
import { computed, watchEffect } from 'vue';
import store from '@/user/store';
import { I18nInfo } from '@/user/models';
import moment from 'moment';
import { Modal, ModalFooter } from '@/user/components/common';
import clsx from 'clsx';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CertificationExamChangeModal',
    props: {
        modelValue: { type: Boolean },
        exam: {}
    },
    emits: ["update:modelValue", "change-exam"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        const t_common = new I18nInfo('common');
        const t = new I18nInfo('certification.applied.modal.change');
        const changableExams = computed(() => store.getters['CertificationStore/changableExams']);
        const styles = {
            wrapper: '',
            titleDesc: clsx('block text-title-2 py-4'),
            note: clsx('text-body-5 text-gray-800', 'desktop:py-4'),
            tableCover: clsx('w-full border-1 border-gray-250 rounded-12 overflow-hidden mt-16'),
            table: 'w-full [&>thead>th:first-child]:border-l-0 [&>tbody>tr>td:first-child]:border-l-0 [&>tbody>tr]:border-b-1 [&>tbody>tr]:border-gray-200',
            th: clsx('w-110 px-23 py-16 text-body-3 bg-gray-150 border-gray-250 border-l-1 text-center [&:first-child]:w-206'),
            td: clsx('px-24 py-17 border-gray-200 border-l-1 text-body-5 text-center [&:first-child]:w-206'),
            textCenter: 'text-center',
        };
        const parseStartDate = (date) => `${moment(date).format('YYYY.MM.DD')} ${moment(date).format('HH:mm')}`;
        watchEffect(async () => {
            if (props.modelValue && props.exam?.id)
                await store.dispatch('CertificationStore/getChangableExam', props.exam.id);
        });
        const showChangeConfirmation = (changeExamId) => {
            store.dispatch('AlertStore/showAlertModal', {
                message: t.translate('confirm'),
                onConfirm: () => handleChangeExam(changeExamId),
            });
        };
        const handleChangeExam = (changeExamId) => {
            emit('change-exam', props.exam, changeExamId);
            isOpen.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                size: "xlarge",
                title: _unref(t).translate('title')
            }, {
                content: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t).translate('note.desc1')), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(t).translate('note.desc2')), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(t).translate('note.desc3')), 1),
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.tableCover)
                    }, [
                        _createElementVNode("table", {
                            class: _normalizeClass(styles.table)
                        }, [
                            _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
                                _createElementVNode("col", { width: "270" }),
                                _createElementVNode("col", { width: "120" }),
                                _createElementVNode("col", { width: "160" }),
                                _createElementVNode("col", { width: "100" }),
                                _createElementVNode("col", { width: "100" }),
                                _createElementVNode("col", { width: "100" }),
                                _createElementVNode("col", { width: "120" })
                            ], -1)),
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('examName')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('level')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('examDate')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('examTime')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('questionCount')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('state')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('apply')), 3)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                (changableExams.value.length === 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                                        _createElementVNode("td", {
                                            class: _normalizeClass([styles.td, 'text-center']),
                                            colspan: 7
                                        }, _toDisplayString(_unref(t).translate('notExamList')), 3)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changableExams.value, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: item.id
                                    }, [
                                        _createElementVNode("td", {
                                            class: _normalizeClass(styles.td)
                                        }, _toDisplayString(item.name), 3),
                                        _createElementVNode("td", {
                                            class: _normalizeClass(styles.td)
                                        }, _toDisplayString(_unref(t_common).translate(`certification.enums.level.${item.level}`)), 3),
                                        _createElementVNode("td", {
                                            class: _normalizeClass(styles.td),
                                            innerHTML: parseStartDate(item.startAt)
                                        }, null, 10, _hoisted_2),
                                        _createElementVNode("td", {
                                            class: _normalizeClass(styles.td)
                                        }, _toDisplayString(item.examTime) + _toDisplayString(_unref(t).translate('timeUnit')), 3),
                                        _createElementVNode("td", {
                                            class: _normalizeClass(styles.td)
                                        }, _toDisplayString(item.questionCount) + _toDisplayString(_unref(t).translate('questionCount')), 3),
                                        _createElementVNode("td", {
                                            class: _normalizeClass(styles.td)
                                        }, _toDisplayString(_unref(t_common).translate(`certification.state.${item.state}`)), 3),
                                        _createElementVNode("td", {
                                            class: _normalizeClass([styles.td, styles.textCenter])
                                        }, [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: _normalizeClass(["text-body-5 flex items-center gap-4", 'text-blue-700']),
                                                    onClick: () => showChangeConfirmation(item.id)
                                                }, _toDisplayString(_unref(t).translate('apply')), 9, _hoisted_4)
                                            ])
                                        ], 2)
                                    ]));
                                }), 128))
                            ])
                        ], 2)
                    ], 2)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter))
                ]),
                _: 1
            }, 8, ["modelValue", "title"]));
        };
    }
});
